import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  contactListData: null,
  orgDetailData: null,
};

const contact = createSlice({
  name: "contact",
  initialState,
  reducers: {
    setContactListData: (state, action) => {
      return {
        ...state,
        contactListData: action.payload,
      };
    },
    setOrgDetailData: (state, action) => {
      console.log(action.payload)
      return {
        ...state,
        orgDetailData: action.payload,
      };
    },
  },
});

export const { setContactListData, setOrgDetailData } = contact.actions;

export default contact.reducer;
